module.exports = __webpack_public_path__ + "omniv2/img/glass.80d64085.jpg";